import { render, staticRenderFns } from "./HistoryControls.vue?vue&type=template&id=d21b68ec&scoped=true"
import script from "./HistoryControls.vue?vue&type=script&lang=js"
export * from "./HistoryControls.vue?vue&type=script&lang=js"
import style0 from "./HistoryControls.vue?vue&type=style&index=0&id=d21b68ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21b68ec",
  null
  
)

export default component.exports